// Asegurar que este archivo es tratado como un módulo
export {};

// Interfaz para los datos del formulario de contacto
export interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  ruc?: string;
  industry?: string;
  service?: string;
  message: string;
  position?: string;
}

// Interfaz para los datos del formulario de cotización
export interface QuoteFormData {
  name: string;
  email: string;
  phone: string;
  company?: string;
  ruc?: string;
  position?: string;
  industry?: string;
  service?: string;
  productType?: string;
  specifications?: string;
  urgency?: string;
  message?: string;
}

// URL del backend (cambiar si usas otro puerto)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

// Función para obtener la URL del backend con el protocolo correcto
const getBackendUrl = () => {
  // Determinar el protocolo basado en el origen actual
  const isHttps = window.location.protocol === 'https:';
  
  // Construir URL del backend con el mismo protocolo que el frontend
  let finalBackendUrl = BACKEND_URL;
  if (isHttps && BACKEND_URL.startsWith('http://')) {
    finalBackendUrl = BACKEND_URL.replace('http://', 'https://');
  } else if (!isHttps && BACKEND_URL.startsWith('https://')) {
    finalBackendUrl = BACKEND_URL.replace('https://', 'http://');
  }
  
  console.log('🌐 Configuración de URL del backend:', {
    originalUrl: BACKEND_URL,
    finalUrl: finalBackendUrl,
    isHttps,
    protocol: window.location.protocol
  });
  
  return finalBackendUrl;
};

// Función para validar formato de email
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Función para enviar correo de contacto a través del backend
export const sendContactEmailViaBackend = async (formData: ContactFormData): Promise<boolean> => {
  try {
    const response = await fetch(`${getBackendUrl()}/send-contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error del backend:', errorData);
      
      // Si es un duplicado (429), considerarlo como éxito para el usuario
      if (response.status === 429 && errorData.error === 'Duplicado detectado') {
        console.log('✅ Duplicado detectado, pero el correo original se envió correctamente');
        return true; // Considerar como éxito para el usuario
      }
      
      return false;
    }

    const result = await response.json();
    return result.success;
  } catch (error) {
    console.error('Error al enviar correo de contacto:', error);
    return false;
  }
};

// Función para enviar correo de cotización a través del backend
export const sendQuoteEmailViaBackend = async (formData: QuoteFormData): Promise<boolean> => {
  try {
    const response = await fetch(`${getBackendUrl()}/send-quote`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error del backend:', errorData);
      
      // Si es un duplicado (429), considerarlo como éxito para el usuario
      if (response.status === 429 && errorData.error === 'Duplicado detectado') {
        console.log('✅ Duplicado detectado, pero el correo original se envió correctamente');
        return true; // Considerar como éxito para el usuario
      }
      
      return false;
    }

    const result = await response.json();
    return result.success;
  } catch (error) {
    console.error('Error al enviar correo de cotización:', error);
    return false;
  }
};